import React, { useState } from "react";
import { Container } from "react-bootstrap";

const Newidea = () => {
  const [fileSelected, setFileSelected] = useState(false);

  const handleFileChange = (e) => {
    setFileSelected(!!e.target.files.length);
  };

  return (
    <div>
      <Container style={{ border: "5px solid", borderRadius: "8px" }}>
        <form>
          <div style={{ display: "flex", padding: "10px" }}>
            <div
              style={{
                marginLeft: "10px",
                flex: 1,
                fontSize: "15px",
                padding: "8px 10px",
                margin: "8px 0",
                display: "inline-block",
                outline: "none",
                border: "5px solid #ccc",
              }}
            >
              <p>
                Please provide details below. If you are reporting a problem,
                always include exact steps to reproduce:
              </p>
            </div>
          </div>
          <label htmlFor="summary">
            <b>Summary</b>
          </label>
          <input
            type="text"
            id="summary"
            name="summary"
            style={{
              width: "100%",
              padding: "12px 20px",
              margin: "8px 0",
              display: "inline-block",
              outline: "none",
              border: "5px solid #ccc",
            }}
            required
          />
          <label htmlFor="description">
            <b>Description</b>
          </label>
          <textarea
            id="description"
            name="description"
            style={{
              width: "100%",
              padding: "12px 20px",
              margin: "8px 0",
              display: "inline-block",
              boxSizing: "border-box",
              border: "5px solid #ccc",
              outline: "none",
              fontWeight: "bold",
              verticalAlign: "top",
            }}
            required
          ></textarea>
          <label htmlFor="file">Attach File</label>
          <input
            type="file"
            id="file"
            name="file"
            onChange={handleFileChange}
            style={{ margin: "8px 0" }}
            required
          />
          {!fileSelected && (
            <p style={{ color: "red" }}>Please select a file</p>
          )}
          <label htmlFor="email">Email</label>
          <input type="email" id="email" name="email" />
          <label htmlFor="name">Name</label>
          <input type="text" id="name" name="name" />
          <div style={{ display: "flex", alignItems: "center" }}>
            <input
              type="checkbox"
              id="environmentInfo"
              name="environmentInfo"
            />
            <label
              htmlFor="environmentInfo"
              style={{ marginLeft: "10px", fontSize: "15px" }}
            >
              Include data about your current environment, like the browser and
              page URL. This helps us understand your feedback better.
            </label>
          </div>
        </form>
      </Container>
    </div>
  );
};

export default Newidea;
